var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "#000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "M1 7.21878C1 4.28722 1 2.82144 1.9336 1.91072C2.86719 1 4.3698 1 7.375 1H11.625C14.6302 1 16.1328 1 17.0664 1.91072C18 2.82144 18 4.28722 18 7.21878V14.2953C18 17.0765 18 18.467 17.1029 18.8924C16.2059 19.3177 15.085 18.4586 12.8432 16.7403L12.1257 16.1904C10.8652 15.2243 10.235 14.7412 9.5 14.7412C8.76504 14.7412 8.13478 15.2243 6.87426 16.1904L6.1568 16.7403C3.91502 18.4586 2.79412 19.3177 1.89706 18.8924C1 18.467 1 17.0765 1 14.2953V7.21878Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.a546b2efb09ae4ac7b848dc92d4e1afb.svg";
export { ForwardRef as ReactComponent };